import { render } from "./Facturas.vue?vue&type=template&id=8c554f2c&scoped=true"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"

import "./Facturas.vue?vue&type=style&index=0&id=8c554f2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c554f2c"

export default script